import Splide from "@splidejs/splide";

export const shopSlider = () => {
  if (document.querySelector(".js-shop-slider") === null) {
    return;
  }

  const slider = document.querySelector(".js-shop-slider");
  const bar = document.querySelector(".js-shop-slider-progress-bar");
  const countCurrent = document.querySelector(".js-shop-slider-count-current");
  const countTotal = document.querySelector(".js-shop-slider-count-total");

  const splide = new Splide(slider, {
    speed: 1000,
    arrows: false, // カスタム矢印を使用するためfalseに
    gap: "2rem",
    perPage: 3,
    perMove: 1,
    lazyLoad: "nearby",
    pagination: false,
    breakpoints: {
      1200: {
        perPage: 2,
      },
      768: {
        perPage: 1,
      },
    },
  });

  splide.on("mounted move", function () {
    var end = splide.Components.Controller.getEnd() + 1;
    var rate = Math.min((splide.index + 1) / end, 1);
    bar.style.width = String(100 * rate) + "%";
    countCurrent.textContent = splide.index + 1;
    countTotal.textContent = end;
  });

  // カスタム矢印のイベントリスナー
  const prevArrow = document.querySelector(".js-shop-slider-prev");
  const nextArrow = document.querySelector(".js-shop-slider-next");

  if (prevArrow) {
    prevArrow.addEventListener("click", () => {
      splide.go("<");
    });
  }

  if (nextArrow) {
    nextArrow.addEventListener("click", () => {
      splide.go(">");
    });
  }

  splide.mount();
};
